import { useEffect,useState } from 'react'
import { TopDisplay } from '../../../../ui-components'
import {Routes,Route} from 'react-router-dom';
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';
import { CreateAdminConfig,ViewConfig,DeleteAdminConfig } from '../Modal';
import { FetchSingleData } from '../../../../hooks/FetchData';
import { config } from '../../../../api';
import { useDispatch, useSelector } from 'react-redux';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
import {RootState} from '../../../../redux/store';
import { setApprovalConfig } from '../../../../redux/reducers/approvalReducer'; 
import { DropdownOption } from '../../../../customs/DropDownOption';
import css3 from '../../Applicants/css/applicant-table.module.css';

const Examination = () => {
  return (
    <ViewWrapper>
        <Routes>
        <Route index element={<Main/>}></Route>
      </Routes>
    </ViewWrapper>
    
  )
}

export default Examination;

export const Options = [
  "View Config",
  "Update Config",
  "Delete Config",
]

const ViewWrapper = styled.div`
  padding:0 20px 20px;
`

const StyledButton = styled.button`
  padding:10px 18px;
  border:none;
  color:white;
  background-color: #11643C;
  border-radius: 5px;
  cursor: pointer;
`

const Main = () => {
  const dispatch = useDispatch();
  const {setShowCancel,setShowModal,setModalContent} = useSettingModal();
  const approvalconfigs = useSelector((store:any) => store.approval.approvalConfig)
  const apiConfig = config;
  const tokenModel = JSON.parse(localStorage.getItem('admin-auth') || '{}');
  const role = JSON.parse(localStorage.getItem('usr_role')|| '{}');
  const roleId  = useSelector((state: RootState) =>state?.user.roleId );
  apiConfig.Authorization = `Bearer ${tokenModel.Token}`;
  const {data:emails,isLoading:loadEmail,isError,error} = FetchSingleData(`roleEmail`,`api/Authentication/GetEmailsFromRoles?RoleId=${roleId}`);
  const {data:aTypes,isLoading:loadaTypes} = FetchSingleData(`approvalT`,`api/ApprovalType/GetApprovalTypes`);
  const {data:mTypes,isLoading:loadmTypes} = FetchSingleData(`membershipT`,`api/Routes/GetMembershipTypes`);

  const {data:aConfig,isLoading:loadConfigs} = FetchSingleData(`allApprovalConfig`,'api/ApprovalConfig/GetApprovalConfigs')
 
  const handleCreateBtn = () =>{
    setModalContent(<CreateAdminConfig emails={emails} aTypes={aTypes}/>);
    setShowCancel(true);
    setShowModal(true);

  }
  useEffect(()=>{
    if(!loadConfigs){
      dispatch(setApprovalConfig(aConfig || []))
    }
  },[loadConfigs,aConfig])
  return (
    <>
      <TopDisplay subTitle="Examination / NYSC" title="Approval Configuration" Btn={
          <StyledButton onClick={handleCreateBtn}>Create Admin Config</StyledButton>
      } />
      <ConfigsTable data={approvalconfigs} emails={emails} aTypes={aTypes}/>
    
    </>
  )
}

export const ConfigsTable = (props:any) =>{
  const [menuIndex,setMenuIndex] = useState<any>(null);
  const data = props.data?props.data:[];
  const emails = props.emails;
  const aTypes = props.aTypes;
  const mTypes = props.mTypes;
  const [pageArr, setPageArr] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [activeArr, setActiveArr] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);

  const {setModalContent,setShowCancel,setShowModal} = useSettingModal();

  const handleModal =(view:string,config:any) =>{
    if(view == 'View Config')setModalContent(<ViewConfig data={config} />)
    else if(view == 'Update Config')setModalContent(<CreateAdminConfig  data={config} emails={emails} aTypes={aTypes} />);
    else if (view == 'Delete Config')setModalContent(<DeleteAdminConfig data={config} />);
    setShowCancel(true);
    setShowModal(true);
    
  }

  const handlePrevious = () =>{
    if(currentPage === 0){
        if(pageArr.length > 1){
            setCurrentPage(pageArr.at(-1))
            return false;
        }
        setCurrentPage(0);
        return false;

    }
    setCurrentPage(currentPage-1);
}

  const handleNext = ()=>{
    if(pageArr.length > 1){
        if(currentPage === pageArr.at(-1)){
            setCurrentPage(0);
            return false;
        }
        setCurrentPage(currentPage+1);
        return false;
      } 
      setCurrentPage(0);
  } 

  const DATA_PER_PAGE = 10;

  useEffect(() => {
    if(data && data.length > 0) {
        setActiveArr(data);

        let lastPage = Math.ceil(data.length/10);
        let i = 0;
        let arr = [];
        for(i = 0; i < lastPage; i++){
            arr.push(i);
        }

        setPageArr(arr);
        setPageData(data.slice(0, DATA_PER_PAGE));

    }
  }, [data])

  useEffect(() => {
    if(activeArr && activeArr.length > 0){    
        let start = currentPage*DATA_PER_PAGE;
        let stop = start+DATA_PER_PAGE;
        setPageData(data.slice(start,stop));  
    }
  }, [currentPage])

  return (
    <TableWrapper>
      <div>
        <span>Approval Type</span>
        <span>Route</span>
        <span>Membership Type</span>
        <span>Role</span>
        <span>Role's Email</span>
      </div>
      <div>
        {pageData && pageData.length > 0 ? pageData?.map((eData:any,index:number)=>
        <EachTableRow  key={index}>
           <span>{eData?.ApprovalTypName || 'Approval Type Name'}</span>
          <span>{eData?.RouteName || 'Route Name'}</span>
          <span>{eData?.MembershipType || 'Membership Type Name'}</span>
          <span>{eData?.RoleName || 'Role Name'}</span>
          <span>
            <div>{eData?.RoleEmails || 'RoleEmails'}</div>
            {/* <span>
              <span><MoreIcon/></span>
              <div>
                 <span></span>
              </div>
            </span> */}
            <DropdownOption options={Options} index={index} user={eData} menuIndex={menuIndex} setMenuIndex={setMenuIndex} onChange={handleModal} />
          </span>
        </EachTableRow>
        ):''}
      </div>
      {/* <div className={css3.pagination}>
        <div>
            <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevious}><LBtn/></button>
            {pageArr && pageArr.length > 0 && pageArr.map((ePage:number)=>
                <span style={ePage == currentPage?{backgroundColor:"var(--activeP-back)",color:"var(--white-color)"}:{}} key={ePage} onClick={()=>setCurrentPage(ePage)}>
                    {ePage+1}
                    </span>)}
            <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
        </div>
      </div> */}
      <div className={css3.pagination}>
                    <div>
                        <button onClick = {handlePrevious} className={`${css3.lBtn} ${css3.btn}`}><LBtn/></button>
                        {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                            if(index <= 2 && currentPage <= 2) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == currentPage ) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == pageArr.length-1) return (
                            <>
                                <>...</>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                            </>
                            )  

                            if(index == 0 ) return (
                            <>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                                <>...</>
                            </>)  

                            })} 
                        <button onClick={handleNext} className={`${css3.rBtn} ${css3.btn}`}><RBtn/></button>
                    </div>
                </div>
    </TableWrapper>
    
  )
}


const EachTableRow = styled.div`
   
   /* width:100%; */
   display: grid;

  grid-template-columns:repeat(4,1fr) 1.5fr;
  &:hover{
    background: #E0FAEE;
  }
  & > span:not(:last-of-type){
    padding:8px 5px;
    min-width:130px;
    overflow: hidden;
    text-overflow:ellipsis;
    /* word-wrap: normal; */
    word-break: keep-all;
  }
  & > span:last-of-type{
    display:flex;
    align-items: center;
    justify-content:space-between;
    position: relative;
  }
  & > span:last-of-type > div{
    overflow: hidden;
    text-overflow:ellipsis;
    word-wrap:nowrap;
    word-break: keep-all;
  }
  & > span:last-of-type > span{
    position:relative;
    display:none;
  }
  /* & > span:last-of-type > span > span{
     display:flex;
    width:30px;
    height:18px;
    align-items:center;
    justify-content: center;
    background-color: #11643C;
    color:#fff;
    cursor: pointer;
    position:absolute;
    right:20px;
    top:-10px;
  } */
  &:hover > span:last-of-type > span {
    display:flex !important;
  }

`

const TableWrapper = styled.div`
  display:flex;
  flex-direction: column;
  gap:5px;
  margin-top:20px;
  & > div:first-of-type{
    width:100%;
    display:grid;
    grid-template-columns:repeat(4,1fr) 1.5fr;
    border-bottom :1px solid #E2E4E9 ;
  }
  & > div:first-of-type > span{
    padding:8px 5px;
    color:#0F324D;
    font-weight: 500;
  }
  & > div:nth-of-type(2){
    /* width:100%; */
    display: flex;
    flex-direction: column;
    row-gap:5px;
    min-height:400px;
  }
  `